import Vue from 'vue'
import Vuex from 'vuex'
import authentication from './modules/authentication'
import orderForm from './modules/orderForm'
import ui from './modules/ui'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    authentication,
    orderForm,
    ui
  }
})
